import { COLOR_TOKENS, type ColorToken } from '@backrs_ui/common-ui/src/designSystem/colors/colors';

import { Box, type SxProps, type Theme, Typography } from '@mui/material';

export type LegendRowProps = Readonly<{
  color: ColorToken;
  label: string;
  pct?: number;
}>;

/** A colour dot and label, with an optional percent chip. */
export const LegendRow = ({ color, label, pct }: LegendRowProps) => (
  <Box sx={pct === undefined ? itemSx : rowSx}>
    <Box sx={dotSx} style={{ backgroundColor: COLOR_TOKENS[color] }} />
    <Typography variant="text-sm-medium" sx={labelSx}>
      {label}
    </Typography>
    {pct === undefined ? null : (
      <Box sx={pctChipSx}>
        <Typography variant="text-xs-medium" sx={pctChipTextSx}>
          {`${pct}%`}
        </Typography>
      </Box>
    )}
  </Box>
);

const dotSx: SxProps<Theme> = ({ backrs }) => ({
  width: 10,
  height: 10,
  borderRadius: backrs.radius['radius-full'],
  flexShrink: 0,
});

const rowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-md'],
});

const itemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
  flexShrink: 0,
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
  whiteSpace: 'nowrap',
});

const pctChipSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  paddingX: backrs.spacing['spacing-md'],
  paddingY: backrs.spacing['spacing-xxs'],
  borderRadius: backrs.radius['radius-md'],
  border: `1px solid ${backrs.colors['Colors/Border/border-primary']}`,
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
});

const pctChipTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});
